// Rutas existentes de App.js/NAV_TREE, sin aliases ni rutas inferidas.
export const MODULE_PATHS = {
  "compras": [
    "/compras"
  ],
  "tesoreria": [
    "/tesoreria"
  ],
  "finanzas": [
    "/finanzas"
  ],
  "contabilidad": [
    "/contabilidad"
  ],
  "ingenieria": [
    "/ingenieria"
  ],
  "obra": [
    "/obra"
  ],
  "inventario": [
    "/inventario"
  ],
  "ventas": [
    "/ventas"
  ],
  "rrhh": [
    "/rrhh"
  ],
  "archivos": [
    "/archivos"
  ],
  "dashboard": [
    "/dashboard"
  ],
  "tareas": [
    "/tareas"
  ],
  "usuarios": [
    "/usuarios"
  ],
  "auditoria": [
    "/auditoria"
  ],
  "configuracion": [
    "/configuracion"
  ]
};
export const MODULE_LANDINGS = {
  "compras": "/compras/materiales",
  "tesoreria": "/tesoreria/pagos",
  "finanzas": "/finanzas/real",
  "contabilidad": "/contabilidad/plan-cuentas",
  "ingenieria": "/ingenieria/proyecto",
  "obra": "/obra",
  "inventario": "/inventario/materiales",
  "ventas": "/ventas",
  "rrhh": "/rrhh",
  "archivos": "/archivos",
  "dashboard": "/dashboard",
  "tareas": "/tareas",
  "usuarios": "/usuarios",
  "auditoria": "/auditoria",
  "configuracion": "/configuracion"
};
